<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showCommissionsModal" :title="$t('Commissions')" size="lg" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable modal-class="mobile-full-screen">
      <commission-tiers :model="model" show-minimum-commission-field/>
      <div class="row">
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="insurance_rate"/>
        </div>
        <div class="col-md-4">
          <currency-input-widget :model="model" attribute="lot_handling_charge"/>
        </div>
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="rebate_rate"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import CommissionTiers from "@/core/components/commission-tiers/CommissionTiers";
  import CommissionForm from "@/modules/customer/models/CommissionForm.model";
  import Commission from "@/core/components/commission-tiers/Commission.model";
  import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget";
  import PercentageInputWidget from "@/core/widgets/PercentageInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CommissionsModal",
    components: {PercentageInputWidget, CurrencyInputWidget, CommissionTiers,  ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new CommissionForm()
      }
    },
    computed: {
      ...mapState({
        reservation: state => state.view.termsData.commissionsModal.reservation,
        editObject: state => state.view.termsData.commissionsModal.object,
        showCommissionsModal: state => state.view.termsData.commissionsModal.show,
      }),
    },
    methods: {
      ...mapActions(['hideCommissionsModal', 'updateLotTerms', 'getReservation']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t('Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?'));
        if (!success) {
          return
        }
        this.loading = true;
        let tmpData = this.model.toJSON();
        let response = await this.updateLotTerms({
          lotUuid: this.reservation.lot.uuid,
          data: {
            minimum_commission: tmpData.minimum_commission,
            lot_handling_charge: tmpData.lot_handling_charge,
            insurance_rate: tmpData.insurance_rate,
            rebate_rate: tmpData.rebate_rate,
            commissions: tmpData.commissions.map(commission => commission.toJSON()),
          }
        });
        this.loading = false
        if (response.success) {
          this.$toast('success', this.$t('Commissions were successfully updated'));
          this.getReservation(this.$route.params.id);
          await this.hideCommissionsModal()
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.model.setErrors(response.body)
          }
        }
      },
      onShow() {
        this.model = new CommissionForm({
          minimum_commission: this.editObject.minimum_commission,
          lot_handling_charge: this.editObject.lot_handling_charge,
          insurance_rate: this.editObject.insurance_rate,
          rebate_rate: this.editObject.rebate_rate,
          commissions: this.editObject.commissions.map(data => new Commission(data))
        }, this.reservation.lot.financial_item.tax_rate)
      },
      onHidden() {
        this.model = new CommissionForm();
        this.hideCommissionsModal();
      },
    },
    watch: {
      'model.rebate_rate'(newValue) {
        if (newValue && parseFloat(newValue) > 0) {
          this.model.minimum_commission = 0;
          if (this.model.commissions && this.model.commissions.length > 0) {
            this.model.commissions[0].percent = 0;
          }
        }
      },
      'model.minimum_commission'(newValue) {
        if (newValue && parseFloat(newValue) > 0) {
          this.model.rebate_rate = 0;
        }
      },
      'model.commissions': {
        handler(commissions) {
          if (commissions && commissions.length > 0) {
            for (let commission of commissions) {
              if (commission.percent && parseFloat(commission.percent) > 0) {
                this.model.rebate_rate = 0;
                break;
              }
            }
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

